import React from 'react';
import { Card, CardHeader, CardBody } from '../../../components/card/card.jsx';
import ToolSelector from './ToolSelector.jsx';

/**
 * Component for the pentest scan form
 */
const ScanForm = ({ 
  siteUrl, 
  setSiteUrl, 
  onSubmit, 
  isLoading, 
  userRole, 
  userName,
  // Tool selection props
  scanners,
  selectedTools,
  scannersByCategory,
  availablePresets,
  hasToolPermission,
  onToolSelection,
  onSelectAll,
  onClearAll,
  onApplyPreset,
  isLoadingScanners
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedTools.length === 0) {
      // This will be handled by the ToolSelector component's warning
      return;
    }
    if (onSubmit) {
      onSubmit(e, selectedTools);
    }
  };

  return (
    <Card>      
      <CardBody>
        {userName && (
          <div className="mb-2">
            <small className="text-muted">
              <i className="fa fa-user me-1"></i>
              Scanning as: <strong>{userName}</strong> ({userRole})
            </small>
          </div>
        )}
        {/* Tool Selection */}
        <ToolSelector
          scanners={scanners}
          selectedTools={selectedTools}
          scannersByCategory={scannersByCategory}
          availablePresets={availablePresets}
          userRole={userRole}
          hasToolPermission={hasToolPermission}
          onToolSelection={onToolSelection}
          onSelectAll={onSelectAll}
          onClearAll={onClearAll}
          onApplyPreset={onApplyPreset}
          isLoading={isLoading || isLoadingScanners}
        />

        {/* Scan Form */}
        <form onSubmit={handleSubmit}>
          <div className="input-group mb-3">
            <span className="input-group-text">Site Address</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter target: domain, IP (v4/v6), or full URL"
                value={siteUrl}
                onChange={(e) => setSiteUrl(e.target.value)}
                disabled={isLoading}
                required
                title="Accepts domain (example.com), IP (1.2.3.4 or [::1]), or URL (http://example.com)"
              />            
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={isLoading || !siteUrl.trim() || selectedTools.length === 0}
                title={
                  isLoading ? 'Pentest scan is currently running...' : 
                  selectedTools.length === 0 ? 'Please select at least one security tool' :
                  'Start a new pentest scan for the specified URL'
                }
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Scanning...
                  </>
                ) : (
                  <>
                    <i className="fa fa-play me-2"></i>
                    Start Scan ({selectedTools.length} tools)
                  </>
                )}
              </button>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default ScanForm;